import { useEffect, useState } from 'react';
import { NotificationDispatch, StyledFlex } from '@tryhackme/thm-ui-components';
import { AzureLabAction } from 'src/common/interfaces';
import { useRunActionMutation } from 'src/features/api/rooms/azure/azure.slice';
import { StyledActions } from '../azure-cloud-details-modal.styles';
import { LabActionsProps } from '../azure-cloud-details-modal.types';
import { LabActionButton } from './lab-action-button';
export const LabActions = ({
  actions,
  roomId,
  taskId,
  labId,
  disableActions
}: LabActionsProps) => {
  const [labActions, setLabActions] = useState(actions);
  useEffect(() => setLabActions(actions), [actions]);
  const [performJoinedLabAction, {
    isLoading: performingLabAction
  }] = useRunActionMutation();
  const [lastClickedAction, setLastClickedAction] = useState<string>();
  const handleActionClick = async (action: AzureLabAction) => {
    setLastClickedAction(action.label);
    try {
      const updatedLab = await performJoinedLabAction({
        taskId,
        roomId,
        labId,
        actionLabel: action.label
      }).unwrap();
      if (updatedLab?.actions) {
        setLabActions(updatedLab.actions);
      }
    } catch {
      NotificationDispatch('error', `Oh no, an error occurred while running this action`);
    }
  };
  return <div data-testid="lab-actions" data-sentry-component="LabActions" data-sentry-source-file="lab-actions.tsx">
      <StyledFlex flexDirection="column" gap="0.8rem" alignItems="flex-start" alignContent="flex-start" justifyContent="flex-start" data-sentry-element="StyledFlex" data-sentry-source-file="lab-actions.tsx">
        <StyledActions data-sentry-element="StyledActions" data-sentry-source-file="lab-actions.tsx">
          {labActions.map(action => <LabActionButton key={action._id} isDisabled={disableActions || performingLabAction} isPerformingAction={action.label === lastClickedAction && performingLabAction} action={action} handleActionClick={handleActionClick} />)}
        </StyledActions>
      </StyledFlex>
    </div>;
};